
export const UpdatedObj = (oldObj,NewObj) =>{
    return{
        ...oldObj,
        ...NewObj
    }
}
